import { jwtDecode } from "jwt-decode";
import { isDevelopment } from "@/shared/helper/environment.helper";
import type { DecodedJwt } from "@/shared/auth/@types/DecodedJwt";
import { getJwt } from "./getJwt.helper";

export const isFrontendAdmin = async () => {
  if (isDevelopment) return true;

  const jwt = await getJwt();
  if (!jwt) return false;

  const decodedIdToken = jwtDecode<DecodedJwt>(jwt);
  const frontendAdmin = decodedIdToken?.custom_attributes?.frontendadmin;

  // The value of frontendadmin is a string containing "true" or "false"
  return frontendAdmin?.toLowerCase() === "true";
};
